import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {connect} from 'react-redux';
import Modal from 'components/Modal';
import ResourcesMatching from 'requests/components/ResourcesMatching';
import {Request, RequestsMixin, PUT} from 'requests';
import classnames from 'classnames';
import HasErrors from 'requests/components/HasErrors';

const mapStateToProps = (state, props) => {
  return {
    ...props,
    requests: state.requests,
  };
};

const KitSettings = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    requests: PropTypes.object.isRequired,
    kit: ImmutablePropTypes.record.isRequired,
    showModal: PropTypes.bool.isRequired,
    onClosed: PropTypes.func.isRequired,
  },

  mixins: [RequestsMixin],

  getInitialState() {
    const {kit} = this.props;

    return {
      kit,
    };
  },

  componentWillReceiveProps(nextProps) {
    const {
      updateKit: updateKitRequest,
    } = this.requests;

    if (this.resourceManager(nextProps).requests.isDone(updateKitRequest)) {
      this.deleteRequest(updateKitRequest);
      this.props.onClosed();
    }
  },

  handleClosed() {
    this.props.onClosed();
  },

  handleSaved() {
    const {kit} = this.state;

    this.setRequest({
      updateKit: new Request({
        method: PUT,
        url: ['api', 'kits', kit.token],
        record: kit,
      }),
    });
  },

  handleNameChanged(event) {
    const {kit} = this.state;

    this.setState({
      kit: kit.set(event.target.name, event.target.value),
    });
  },

  render() {
    const {
      kit,
    } = this.state;
    const {
      updateKit: updateKitRequest,
    } = this.requests;
    const rm = this.resourceManager();
    const hasErrors = rm.requests.hasErrors(updateKitRequest);
    const isSaving = rm.requests.isQueued(updateKitRequest);
    const nameClassNames = classnames(
      'form-group',
      'm-xs-b-md',
      {'has-danger': hasErrors},
    );

    const submitLabel = (isSaving) ? 'Saving...' : <span>Save Changes <i className="ficon ficon-check-circle p-xs-l-xs"></i></span>;

    return (
      <Modal contentLabel="Kit settings" isOpen={this.props.showModal} onRequestClose={this.handleClosed}>
        <ResourcesMatching manager={rm}>
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content">
              <div className="modal-header bg-body dashed dashed-bottom m-xs-b-xs p-xs-b-sm">
                <button onClick={this.handleClosed} type="button" className="close close-dangle" aria-label="Close">
                  <span aria-hidden="true"><i className="ficon ficon-times"></i></span>
                </button>
                <h3 className="modal-title"><i className="ficon ficon-pencil"></i> Edit Kit Name</h3>
              </div>
              <div className="modal-body">
                <div className="lead m-xs-b-md">Want to change the name of your Kit?</div>
                <div className={nameClassNames}>
                  <input className="required form-control form-control-lg" type="text" value={kit.name} name="name" placeholder="Kit Name" onChange={this.handleNameChanged} />
                  <HasErrors request={updateKitRequest} errorKey="name">
                    <span className="text-help text-muted p-xs-t-xs">{rm.requests.errorsFor(updateKitRequest).get('name')}</span>
                  </HasErrors>
                </div>
              </div>
              <div className="modal-footer bg-body">
                <button onClick={this.handleClosed} type="button" className="btn btn-secondary btn-lg">Cancel</button>
                <button onClick={this.handleSaved} type="submit" disabled={isSaving} className="btn btn-primary btn-lg">
                   {submitLabel}
                </button>
              </div>
            </div>
          </div>
        </ResourcesMatching>
      </Modal>
    );
  },
});

export default connect(mapStateToProps)(KitSettings);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/KitSettings.js